import {Bar} from 'vue-chartjs'

export default {
    extends: Bar,
    data() {
        return {
            query: '',
            stop: false,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                showTooltips: false,
                showInlineValues: true,
                centeredInllineValues: true,
                scales: {
                    xAxes: [{
                        stacked: true,
                        categoryPercentage: 0.5,
                        barPercentage: 1
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                }
            },
            reject_count: [],
            labels: []
        }
    },
    methods: {
        render() {
            this.renderChart({
                labels: this.labels,
                datasets: [
                    {
                        type: 'bar',
                        label: this.unique ? 'Unique ' : '' + 'Fake Reject',
                        tooltipTemplate: 'ddd',
                        backgroundColor: 'red',
                        data: this.reject_count,
                    }
                ]
            }, this.options);
        },
        init(data) {
            this.labels = [];
            this.reject_count = [];
            data.forEach(e => {
                this.labels.push(Number.parseInt(e.hour));
                this.reject_count.push(Number.parseInt(e.count));
            });
            this.render();
        }
    },
    props: {
        unique: {
            type: Boolean,
            default: false
        }
    }
};